import Vue from 'vue'
import Router from 'vue-router'
import Arecord from '@/views/kiwoom/usRecord/pc/Arecord'
import Brecord from '@/views/kiwoom/usRecord/pc/Brecord'
import Crecord from '@/views/kiwoom/usRecord/pc/Crecord'
import Drecord from '@/views/kiwoom/usRecord/pc/Drecord'
import Erecord from '@/views/kiwoom/usRecord/pc/Erecord'
import MbArecord from '@/views/kiwoom/usRecord/mb/Arecord'
import MbBrecord from '@/views/kiwoom/usRecord/mb/Brecord'
import MbCrecord from '@/views/kiwoom/usRecord/mb/Crecord'
import MbDrecord from '@/views/kiwoom/usRecord/mb/Drecord'
import MbErecord from '@/views/kiwoom/usRecord/mb/Erecord'
import MbNews from '@/views/kiwoom/usRecord/mb/UsNews'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Arecord
    },
    {
      path: '/kw/us/p/aRecord',
      name: 'Arecord',
      component: Arecord
    },
    {
      path: '/kw/us/p/bRecord',
      name: 'Brecord',
      component: Brecord
    },
    {
      path: '/kw/us/p/cRecord',
      name: 'Crecord',
      component: Crecord
    },
    {
      path: '/kw/us/p/dRecord',
      name: 'Drecord',
      component: Drecord
    },
    {
      path: '/kw/us/p/eRecord',
      name: 'Erecord',
      component: Erecord
    },
    {
      path: '/kw/us/m/aRecord',
      name: 'MbArecord',
      component: MbArecord
    },
    {
      path: '/kw/us/m/bRecord',
      name: 'MbBrecord',
      component: MbBrecord
    },
    {
      path: '/kw/us/m/cRecord',
      name: 'MbCrecord',
      component: MbCrecord
    },
    {
      path: '/kw/us/m/dRecord',
      name: 'MbDrecord',
      component: MbDrecord
    },
    {
      path: '/kw/us/m/eRecord',
      name: 'MbErecord',
      component: MbErecord
    },
    {
      path: '/kw/us/m/news',
      name: 'MbNews',
      component: MbNews
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js